import { render, staticRenderFns } from "./JStorageBackendList.vue?vue&type=template&id=5ddba474&"
import script from "./JStorageBackendList.vue?vue&type=script&lang=js&"
export * from "./JStorageBackendList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports